import { render } from "./UpgradePrompt.vue?vue&type=template&id=680b631c&scoped=true"
import script from "./UpgradePrompt.vue?vue&type=script&lang=js"
export * from "./UpgradePrompt.vue?vue&type=script&lang=js"

import "./UpgradePrompt.vue?vue&type=style&index=0&id=680b631c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680b631c"]])

export default __exports__